/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWorkIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-work"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 21.8Q2.75 21.8 1.98 21.02Q1.2 20.25 1.2 19.15L1.2 8.2Q1.2 7.1 1.98 6.33Q2.75 5.55 3.85 5.55L7.3 5.55L7.3 3.55Q7.3 2.45 8.07 1.68Q8.85 0.9 9.95 0.9L14.05 0.9Q15.15 0.9 15.93 1.68Q16.7 2.45 16.7 3.55L16.7 5.55L20.15 5.55Q21.25 5.55 22.02 6.33Q22.8 7.1 22.8 8.2L22.8 19.15Q22.8 20.25 22.02 21.02Q21.25 21.8 20.15 21.8ZM9.95 5.55L14.05 5.55L14.05 3.55Q14.05 3.55 14.05 3.55Q14.05 3.55 14.05 3.55L9.95 3.55Q9.95 3.55 9.95 3.55Q9.95 3.55 9.95 3.55Z" fill={color} />
    </svg>
  );
}
